function Navbar() {
  return (
	    <div
	      className="
	        bg-white
	        text-slate-950
	        px-6
	        py-3
	        border-b
	        border-slate-200
          sticky
          top-0
          z-20
	      "
    >
      <div className="mx-auto flex flex-wrap gap-3 items-center justify-between max-w-6xl">
        <div>
          <p className="text-lg font-extrabold leading-tight">Shift Manager</p>
          <p className="text-xs font-semibold text-slate-500">Shift, attendance, payroll</p>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
